import Cookies from 'js-cookie';
import {useEffect} from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import App from '../App';
import {AppBar} from '../components';
import Current from '../pages/current/current.tsx';
import EditBankCard from '../pages/profile/EditBankCard';
import EditProfile from '../pages/profile/EditProfile';
import {initialApis} from '../services/apis/global';
import {AppDispatch, useAppDispatch, useAppSelector} from '../services/redux/store';
import Layout from './layout';
import Bill from '../pages/bill/bill.tsx';
import Login from '../pages/login/login';
import Orders from '../pages/orders/orders';
import AddressManage from '../pages/profile/AddressManage';
import Profile from '../pages/profile/profile';
import Feedback from '../pages/feedback/feedback';

export default function Website() {
  const dispatch: AppDispatch = useAppDispatch();
  const userReducer = useAppSelector((state) => state.userReducer);
  const navigate = useNavigate();

  useEffect(() => {
    initialApis(dispatch, navigate);
  }, []);

  return (
    <Routes>
      <Route
        path="/"
        element={
          <Layout>
            <Current />
          </Layout>

        }
      />
      <Route
        path="/bill"
        element={
          <Layout>
            <Bill />
          </Layout>

        }
      />
      <Route
        path="/orders"
        element={
          <Layout>
            <Orders />
          </Layout>
        }
      />
      <Route
        path="/profile"
        element={
          <Layout>
            <Profile />
          </Layout>
        }
      />
      <Route path="/feedback/:id" element={<Feedback />} />
      <Route path="/profile/edit" element={<EditProfile />} />
      <Route path="/profile/bank" element={<EditBankCard />} />
      <Route path="/address/edit/:id" element={<AddressManage />} />
      <Route path="/address/add" element={<AddressManage />} />
      <Route
        path="/login"
        element={
          <>
            <Login />
            <AppBar />
          </>
        }
      />
    </Routes>
  );
}
